<template>
  <div>
    <transition name="slide-right">
      <div class="logsuspend">
        <ul class="logsupendul" v-if="backflag==true">
          <li
            class="logsupendli"
            @mouseenter="changeImageSrc(1, 'hover')"
            @mouseleave="changeImageSrc(1, '')"
            @click.stop="clickBtnlist('login')"
            v-if="!tokenn"
          >
            <div class="logsupendli-center">
              <img :src="prevImg01" alt />
              <span>登录</span>
            </div>
          </li>

          <li
            class="logsupendli"
            @mouseenter="changeImageSrc(6, 'hover')"
            @mouseleave="changeImageSrc(6, '')"
            @click.stop="clickreturnhome"
            v-if="tokenn"
          >
            <div class="logsupendli-center">
              <img :src="prevImg06" alt />
              <span>返回首页</span>
            </div>
          </li>

          <!-- <li
            class="logsupendli"
            @mouseenter="changeImageSrc(2, 'hover')"
            @mouseleave="changeImageSrc(2, '')"
            v-if="!tokenn"
          >
            <div class="logsupendli-center">
              <img :src="prevImg02" alt />
              <span>注册</span>
            </div>
          </li>-->

          <li
            style="height:120px"
            class="logsupendli"
            @mouseenter="changeImageSrc(5, 'hover')"
            @mouseleave="changeImageSrc(5, '')"
            v-if="tokenn && !isManager"
          >
            <div class="logsupendli-center" @click="personCenter()">
              <img :src="person.photo" alt style="width:40px;height:40px;border-radius: 50%;" />
              <div style="font-size:12px;margin-top:13px">{{person.name}}</div>
              <span style="font-size:10px">个人中心</span>
            </div>
          </li>

          <!-- <el-popover placement="left" trigger="hover">
            <img src="@/assets/APP二维码.png" style="width:130px;height:130px" />

            <li
              class="logsupendli"
              slot="reference"
              @mouseenter="changeImageSrc(3, 'hover')"
              @mouseleave="changeImageSrc(3, '')"
            >
              <div class="logsupendli-center">
                <img :src="prevImg03" alt />
                <span>移动APP</span>
              </div>
            </li>
          </el-popover>-->
          <!-- <li
            class="logsupendli"
            @mouseenter="changeImageSrc(3, 'hover')"
            @mouseleave="changeImageSrc(3, '')"
          >
            <div class="logsupendli-center">
              <img :src="prevImg03" alt />
              <span>手机APP</span>
            </div>
          </li>-->

          <li
            class="logsupendli"
            @mouseenter="changeImageSrc(2, 'hover')"
            @mouseleave="changeImageSrc(2, '')"
            @click="goSystiem()"
            v-if="tokenn && isManager"
          >
            <div class="logsupendli-center">
              <img :src="prevImg02" alt />
              <span>后台管理</span>
            </div>
          </li>
          <li
            class="logsupendli"
            @mouseenter="changeImageSrc(7, 'hover')"
            @mouseleave="changeImageSrc(7, '')"
            @click="goOut()"
            v-if="tokenn"
          >
            <div class="logsupendli-center">
              <img :src="prevImgexit" alt />
              <span>退出登录</span>
            </div>
          </li>
          <li
            class="logsupendli"
            @mouseenter="changeImageSrc(8, 'hover')"
            @mouseleave="changeImageSrc(8, '')"
            @click="feedBack()"
          >
            <div class="logsupendli-center">
              <img :src="prevImg08" alt />
              <span>意见反馈</span>
            </div>
          </li>
          <li
          class="logsupendli"
          v-if="tokenn && isManager"
          @click.stop="toUpFileUrl"
          >
            <div class="logsupendli-center">
              <i style="font-size:36px;color:#266EED;" class="el-icon-upload"></i>
              <span>文件上传</span>
            </div>
          </li>
          <div
            class="logsupendli logsupendli7"
            @mouseenter="changeImageSrc(4, 'hover')"
            @mouseleave="changeImageSrc(4, '')"
            @click="takeback()"
          >
            <div class="logsupendli-center">
              <img style="width:30px;height:30px;" :src="prevImg04" alt />
            </div>
          </div>
        </ul>
        <div @click="takeback()" v-if="backflag==false" class="jiantou">
          <img class="arrowsleft" src="@/assets/images/home/chevron-back-outline.svg" />
        </div>
      </div>
    </transition>
    <el-dialog :visible.sync="feedBackDialog" title="意见反馈" width="700px" class="dialog-mini">
      <el-form :model="feedBackFrom" :rules="feedBackRules" ref="feedBackFrom" label-width="100px">
        <el-form-item label="类别" prop="type">
          <el-radio-group v-model="feedBackFrom.type">
            <el-radio :label="1">使用意见</el-radio>
            <el-radio :label="2">应用需求</el-radio>
            <el-radio :label="3">系统bug</el-radio>
            <el-radio :label="4">其它问题</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="使用意见" prop="idea">
          <el-input type="textarea" v-model="feedBackFrom.idea" :rows="5"></el-input>
        </el-form-item>
        <el-form-item label="附件">
          <div style="display: flex">
            <el-upload
              ref="myupload"
              :headers="headers"
              action="/resource/File/UploadFile"
              :on-remove="activityFileHandleRemove"
              :on-success="activitysuccess"
              multiple
              v-model="feedBackFrom.fileUrl"
              :file-list="fileLists"
              accept=".doc, .docx, .mp4, .avi, .jpg, .jpeg, .png, .svg, .gif"
              :limit="1"
              :show-file-list="false"
            >
              <el-button type="primary">上传</el-button>
            </el-upload>
            <el-button
              style="margin-left: 10px"
              v-if="feedBackFrom.fileUrl"
              @click="activityFileHandleLook"
            >查看</el-button>
            <el-button v-if="feedBackFrom.fileUrl" @click="activityFileHandleRemove">移除</el-button>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="feedBackDialog = false">取 消</el-button>
        <el-button type="primary" @click="addfeedBack">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getInfo, removeInfo } from '@/utils/auth';
import * as message from '@/api/message/index';
export default {
  data() {
    return {
      fileLists: [],
      gray: this.$store.getters.gray,
      dataTheme: this.$store.getters.dataTheme,
      templates: this.$store.getters.templates,
      bannerUrl: '',
      tokenn: getInfo('tokens'), // 判断是否登录
      person: getInfo('infos') ? JSON.parse(getInfo('infos')) : '',
      moovflag: false, //当鼠标移入手机app是显示左边二维码
      backflag: true,
      preflag: true,
      prevImg01: require('@/assets/newIndex/lg.png'),
      prevImg02: require('@/assets/newIndex/mgt.png'),
      prevImg03: require('@/assets/newIndex/ap.png'),
      prevImg04: require('@/assets/newIndex/arrawactive.png'),
      // prevImg05: require('@/assets/newIndex/mgt.png'),
      prevImg08: require('@/assets/newIndex/viewIcon.png'),
      prevImgexit: require('@/assets/newIndex/exit.png'),
      prevImg06: require('@/assets/icon/home.svg'),
      isManager: false,
      feedBackDialog: false,

      feedBackFrom: {
        type: null,
        idea: null,
        status: 0,
        fileUrl: null,
        createId: this.$store.state.User.ids ? this.$store.state.User.ids : 0,
        createName: '',
      },
      feedBackRules: {
        type: [{ required: true, message: '请选择类别', trigger: 'change' }],
        idea: [{ required: true, message: '请输入反馈意见', trigger: 'blur' }],
      },
    };
  },
  watch:{
    info_tirgger: function () {
      this.person = JSON.parse(getInfo('infos'));
      this.isManager =this.person.isManger
      this.tokenn=this.person.token
    },
  },
  computed: {
    headers() {
      return {
        Authorization: 'Bearer ' + this.$store.getters.tokens,
      };
    },
    info_tirgger() {
      return this.$store.state.User.infos;
    },
  },


  methods: {
    addfeedBack() {
      this.$refs.feedBackFrom.validate((valid) => {
        if (valid) {
          if (this.$store.state.User.infos) {
            this.feedBackFrom.createName = this.$store.state.User.infos.name;
          }

          message.addUserFeedback(this.feedBackFrom).then((res) => {
            this.$message.success('成功');
            this.feedBackDialog = false;
            this.$refs.feedBackFrom.resetFields();
          });
        }
      });
    },
    activityFileHandleLook() {
      if (this.feedBackFrom.fileUrl == '') {
        this.$notify({
          title: '失败',
          message: '没有文件可查看',
          type: 'warning',
        });
      } else {
        //下载文件
        window.open(this.feedBackFrom.fileUrl);
      }
    },
    activityFileHandleRemove(file, fileList) {
      this.feedBackFrom.fileUrl = '';
      this.$nextTick(() => {
        this.$refs.myupload.clearFiles();
      });
    },
    activitysuccess(response, file, fileList) {
      this.feedBackFrom.fileUrl = response.result;
    },
    //点击意见反馈
    feedBack() {
      this.fileLists = [];
      this.feedBackFrom = {
        type: null,
        idea: null,
        status: 0,
        fileUrl: null,
        createId: this.$store.state.User.ids ? this.$store.state.User.ids : 0,
        createName: this.$store.state.User.infos.name,
      };
      this.feedBackDialog = true;
    },
    //搜索
    searcha() {
      this.$router.push({
        path: '/search',
        query: {},
      });
    },
    // 后台管理
    goSystiem() {
      let toke = getInfo('tokens');
      if(!toke){
        window.location.reload();
        return false
      }
      // http://121.12.125.214:2369   http://localhost:8086
      let managerUrl = localStorage.getItem('managerUrl');

      window.open(`${managerUrl}/index?token=` + toke);
    },
    // 退出功能
    goOut(){
      var _this = this;
      _this.$confirm('确认退出吗?', '提示', {}).then(() => {
        _this.$store.dispatch('logout').then(() => {
          _this.$router.push('/home');
          window.location.reload();
        });
      });
    },
    // 点击登录
    clickBtnlist(val) {
      this.$emit(val);
      console.log(val);
    },
    // 点击切换图片
    changeImageSrc(key, way) {
      let hoverStr = way === 'hover' ? 'active' : '';
      switch (key) {
        case 1:
          this.prevImg01 = require(`@/assets/newIndex/lg${hoverStr}.png`);
          break;
        case 2:
          this.prevImg02 = require(`@/assets/newIndex/mgt${hoverStr}.png`);
          break;
        case 3:
          this.prevImg03 = require(`@/assets/newIndex/ap${hoverStr}.png`);
          this.moovflag = true;
          break;
        case 4:
          // this.prevImg04 = require(`@/assets/newIndex/mgt${hoverStr}.png`);
          this.showFlag = false;
          break;
        case 5:
          this.prevImg06 = require(`@/assets/icon/home${hoverStr}.svg`);
          this.showFlag = false;
          break;
        case 8:
          this.prevImg08 = require(`@/assets/newIndex/viewIcon${hoverStr}.png`);
          break;
      }
      if (way == '') {
        this.moovflag = false;
      }
    },
    //点击个人中心跳转到页面
    personCenter() {
      if (this.$route.path == '/personCenter/personhome') {
        return;
      } else {
        this.$router.push('/personCenter/personhome');
      }
    },
    clickreturnhome() {
      this.$router.push('/home');
    },
    //点击缩回和放出登录栏
    takeback() {
      this.backflag = !this.backflag;
    },
    grayHandleChange(val) {
      this.$store.dispatch('setGray', val);
    },
    dataThemeHandleChange(val) {
      this.$store.dispatch('setDataTheme', val);
    },
    clickBtn(val) {
      this.$emit(val);
    },
    //跳转文件上传
    toUpFileUrl(){
      this.$router.push({path:'/home/upFileWork'});
    }
  },
  created() {
    this.bannerUrl = require('@/assets/images/home/headerbanner.png');
    if (this.$store.state.User.infos) {
      //判断是否登录，是的或取值，没登录取值会报错
      this.person = JSON.parse(getInfo('infos'));
      this.isManager = this.person.isManger;
      this.tokenn=this.person.token
    } 

    if (this.$route.path == '/home') {
      this.preflag = false;
    }

    if (
      this.$route.path == '/BrushTopic' ||
      this.$route.path == '/studyclass' ||
      this.$route.path == '/diaoy/questionget'
    ) {
      this.backflag = false;
    }
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.logsuspend {
  // position: absolute;
  position: fixed;
  right: 40px;
  top: 100px;
  bottom: 48px;
  z-index: 30;

  .logsupendul {
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 0 0 10px rgb(242 242 242 / 99%);
    .logsupendli {
      width: 80px;
      padding: 5px 0;
      display: flex;
      align-items: center;
      justify-content: center;

      color: #999;
      .logsupendli-center {
        text-align: center;
        width: 100%;
        img {
          display: block;
          width: 40px;
          height: 40px;
          margin: 0 auto;
        }
        span {
          display: block;
          font-size: 14px;
          margin-top: 2px;
        }
      }
      &:hover {
        background-color: #1492ff;
        color: #fff;
        cursor: pointer;
      }
    }
    .logsupendli7 {
      width: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #666;
      border: 0;
      height: 50px;
      background-color: #7f7f7f;
      border-radius: 0 0 5px 5px;
      img {
        width: 28px;
        height: 28px;
      }
    }
  }
  .arrowsleft {
    width: 24px;
    height: 62px;
    position: absolute;
    left: -24px;
    top: 50%;
    margin-top: auto;
  }
}

.slide-right-enter,
.slide-right-leave-active {
  transform: translateX(120px);
}
.slide-right-leave-active,
.slide-right-enter-active {
  transition: all 0.6s 0.6s cubic-bezier(0.33, 0.25, 0.33, 1);
}

// -----------
.user-defined {
  padding: 10px 0;
}

.user-defined:nth-child(1),
.user-defined:nth-child(2) {
  border-bottom: 1px solid #ddd;
}

.user-defined > .user-defined {
  padding-bottom: 0;
  border-bottom-width: 0;
}
.phoneapp {
  width: 200px;
  height: 200px;
  background-image: url('../../assets/APP二维码.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-color: #333;
  position: fixed;
  top: 33%;
  left: 83%;
}
.jiantou > img {
  background-color: #ccc;
  border-radius: 5px;
}
.jiantou > img:hover {
  cursor: pointer;
  background-color: rgb(108, 176, 231);
}
</style>